import { gql } from '@apollo/client';
export const PUBLIC_CLIENT_CAMPAIGN_FRAGMENT = gql `
  fragment PublicClientCampaignFragment on Campaign {
    id
    name
    code
    contactEmail
    contactPhone {
      code
      number
    }
    logo {
      id
      downloadUrl
    }
    image {
      id
      downloadUrl
    }
    city
    state
    campaignType
    fundraisingGoal
    fundraiserGoal
    attendanceFundraisersCountGoal
    teamGoal
    donorGoal
    totalRaised
    startDate
    endDate
    campaignStatus
    createdAt
    updatedAt
    createdBy {
      id
      firstName
      lastName
    }
    vizslaOrganization {
      id
      name
    }
  }
`;
const CLIENT_CAMPAIGN_FRAGMENT = gql `
  fragment ClientCampaignFragment on Campaign {
    id
    name
    code
    contactEmail
    contactPhone {
      code
      number
    }
    logo {
      id
      downloadUrl
    }
    image {
      id
      downloadUrl
    }
    city
    state
    campaignType
    fundraisingGoal
    fundraiserGoal
    attendanceFundraisersCountGoal
    teamGoal
    teams {
      count
      items {
        id
        createdAt
      }
    }
    donorGoal
    donors {
      count
    }
    totalRaised
    startDate
    endDate
    campaignStatus
    webLink
    program {
      id
      name
    }
    createdAt
    updatedAt
    createdBy {
      id
      firstName
      lastName
    }
    experiences {
      items {
        id
        name
        waiverEnabled
        waiverTextBody
        experienceType
        startDate
        endDate
        ticketingOptions {
          items {
            id
            ticketName
          }
        }
        registrationOptions {
          items {
            id
            name
          }
        }
        experienceLogoImage {
          id
          downloadUrl
        }
        image {
          id
          downloadUrl
        }
        experienceHeaderImage {
          id
          downloadUrl
        }
      }
    }
    dnsRecord {
      id
      slug
    }
    campaignTemplates {
      id
      templates {
        items {
          id
          structure
          templateType {
            type
            title
          }
        }
      }
    }
  }
`;
export const CLIENT_CAMPAIGN_QUERY = gql `
  query ClientCampaign($id: ID!) {
    campaign(id: $id) {
      ...ClientCampaignFragment
    }
  }
  ${CLIENT_CAMPAIGN_FRAGMENT}
`;
export const PUBLIC_TEMPLATES_BY_CAMPAIGN_ID_QUERY = gql `
  query PublicTemplatesByCampaignId($campaignId: ID!) {
    campaign(id: $campaignId) {
      campaignTemplates {
        id
        templates {
          items {
            id
            templateType {
              type
              title
            }
          }
        }
      }
    }
  }
`;
export const CLIENT_SINGLE_CAMPAIGN_STATISTICS_QUERY = gql `
  query ClientSingleCampaignStatistics($campaignId: ID!) {
    attendeesList(filter: { experience: { campaign: { id: { equals: $campaignId } } } }) {
      count
      items {
        id
        createdAt
      }
    }
    fundraisersList: attendeesList(
      filter: {
        experience: { campaign: { id: { equals: $campaignId } } }
        fundraisingPageLink: { is_not_empty: true }
      }
    ) {
      count
      items {
        id
        createdAt
      }
    }
  }
`;
const CAMPAIGN_HEADER_IMAGE_FRAGMENT = gql `
  fragment CampaignHeaderImageFragment on Campaign {
    campaignType
    experiences {
      items {
        id
      }
    }
    image {
      id
      filename
      downloadUrl
      fileId
      public
    }
  }
`;
const CAMPAIGN_HEADER_LOGO_FRAGMENT = gql `
  fragment CampaignHeaderLogoFragment on Campaign {
    campaignType
    experiences {
      items {
        id
      }
    }
    logo {
      id
      filename
      downloadUrl
      fileId
      public
    }
  }
`;
export const CAMPAIGN_HEADER_IMAGE = gql `
  ${CAMPAIGN_HEADER_IMAGE_FRAGMENT}

  query CampaignHeaderImage($id: ID!) {
    campaign(id: $id) {
      ...CampaignHeaderImageFragment
    }
  }
`;
export const CAMPAIGN_LOGO_IMAGE_QUERY = gql `
  ${CAMPAIGN_HEADER_LOGO_FRAGMENT}
  query CampaignLogoImage($id: ID!) {
    campaign(id: $id) {
      ...CampaignHeaderLogoFragment
    }
  }
`;
export const CAMPAIGN_HEADER_IMAGE_UPDATE = gql `
  ${CAMPAIGN_HEADER_IMAGE_FRAGMENT}

  mutation CampaignHeaderImagesUpdate($data: CampaignUpdateInput!, $filter: CampaignKeyFilter) {
    campaign: campaignUpdate(data: $data, filter: $filter, destroyDetached: true) {
      ...CampaignHeaderImageFragment
    }
  }
`;
export const CAMPAIGN_HEADER_LOGO_UPDATE_MUTATION = gql `
  ${CAMPAIGN_HEADER_LOGO_FRAGMENT}
  mutation CampaignHeaderLogoUpdate($data: CampaignUpdateInput!, $filter: CampaignKeyFilter) {
    campaign: campaignUpdate(data: $data, filter: $filter, destroyDetached: true) {
      ...CampaignHeaderLogoFragment
    }
  }
`;
